class TrackingEventWorkflowCurrentStatus {
    constructor({status, data: { reportText: currentReportText, updatedEvent: updatedEvent, updatedReportData: reportData } = {}}) {
        this.workflowStatus = status;
        this._currentReportText = currentReportText;
        this._updatedEventData = updatedEvent;
        this._updatedReportData = reportData;
    }

    get currentReportText() {
        return this._currentReportText;
    }

    get updatedEvent() {
        return this._updatedEventData;
    }

    get updatedReportData() {
        return this._updatedReportData;
    }

    toString() {
        return `Tracking Event Workflow Status: '${this.workflowStatus}'`;
    }
}

export default TrackingEventWorkflowCurrentStatus;


//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-editor/event-transition/TrackingEventWorkflowCurrentStatus.js
// module id = 8Z+J
// module chunks = 1